import { Box, Container, Group, List, Text, ThemeIcon, Title } from '@mantine/core';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { FaCheck, FaEnvelope } from 'react-icons/fa';

export default function AboutUs() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <Container size="lg" py="xl">
            <Helmet>
                <title>{`About Us - Thrift Store Nepal`}</title>
                <meta
                    name="description"
                    content="Products - Thrift Store Nepal - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
                />
                <meta property="og:title" content="Products - Thrift Store Nepal" />
                <meta
                    property="og:description"
                    content="Products - Thrift Store Nepal - Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
                />
                <meta name="og:image" content="/assets/images/og-2.png" />
            </Helmet>
            <Title order={1} align="center" mb="xl">
                About Us
            </Title>

            <Box mb="xl">
                <Title order={2} mb="md">Welcome to Thrift Store Nepal!</Title>
                <Text>
                    At Thrift Store Nepal, we believe in the power of sustainability, affordability, and community.
                    We are an online platform dedicated to making second-hand fashion accessible to everyone in Nepal
                    while promoting a sustainable lifestyle.
                </Text>
            </Box>

            <Box mb="xl">
                <Title order={2} mb="md">Our Mission</Title>
                <Text mb="sm">Our mission is simple:</Text>
                <List
                    spacing="sm"
                    icon={
                        <ThemeIcon color="teal" size={24} radius="xl">
                            <FaCheck size={14} />
                        </ThemeIcon>
                    }
                >
                    <List.Item>Empower Sellers: Provide individuals with a hassle-free platform to sell their pre-loved clothes.</List.Item>
                    <List.Item>Connect Communities: Bring together people who value quality, affordability, and sustainability.</List.Item>
                    <List.Item>Promote Sustainability: Reduce waste and encourage the culture of reusing and recycling fashion items.</List.Item>
                </List>
            </Box>

            <Box mb="xl">
                <Title order={2} mb="md">How It Works</Title>
                <List
                    spacing="sm"
                    withPadding
                >
                    <List.Item>
                        <Text fw={600}>Sign Up & Sell:</Text> Anyone can create an account, upload photos of their clothes,
                        and list their items for sale. Once approved, your products will be visible to buyers.
                    </List.Item>
                    <List.Item>
                        <Text fw={600}>Shop Smart:</Text> Buyers can browse through a wide selection of second-hand clothing,
                        connect with sellers directly, and chat before making a purchase.
                    </List.Item>
                    <List.Item>
                        <Text fw={600}>No Middlemen:</Text> We don't charge any commission, and transactions happen directly
                        between buyers and sellers.
                    </List.Item>
                </List>
            </Box>

            <Box mb="xl">
                <Title order={2} mb="md">Why Choose Us?</Title>
                <List
                    spacing="sm"
                    icon={
                        <ThemeIcon color="teal" size={24} radius="xl">
                            <FaCheck size={14} />
                        </ThemeIcon>
                    }
                >
                    <List.Item>Affordable Fashion: Shop high-quality pre-loved clothes at prices you'll love.</List.Item>
                    <List.Item>Sustainable Lifestyle: Join us in reducing fashion waste and creating a positive impact on the environment.</List.Item>
                    <List.Item>Community-Oriented: Our platform is built for you—whether you're decluttering your wardrobe or hunting for unique finds.</List.Item>
                </List>
            </Box>

            <Box mb="xl">
                <Title order={2} mb="md">Our Values</Title>
                <List withPadding>
                    <List.Item>
                        <Text fw={600}>Transparency:</Text> We provide a simple and honest platform with no hidden fees.
                    </List.Item>
                    <List.Item>
                        <Text fw={600}>Sustainability:</Text> We are committed to reducing fashion's environmental footprint.
                    </List.Item>
                    <List.Item>
                        <Text fw={600}>Inclusivity:</Text> We aim to make second-hand fashion accessible to everyone in Nepal.
                    </List.Item>
                </List>
            </Box>

            <Box mb="xl">
                <Title order={2} mb="md">Join the Thrift Revolution</Title>
                <Text>
                    By choosing Thrift Store Nepal, you're not just shopping or selling—you're becoming part of a movement
                    that values mindful consumption and sustainable living. Whether you're decluttering your wardrobe or
                    searching for hidden gems, we are here to make your experience seamless and enjoyable.
                </Text>
            </Box>

            <Box mb="xl">
                <Title order={2} mb="md">Contact Us</Title>
                <Text mb="md">Have questions or need assistance? We're here to help!</Text>
                <Group spacing="xl">
                    <Group spacing="xs">
                        <FaEnvelope size={18} />
                        <Text>Email: info@thriftstorenepal.com</Text>
                    </Group>

                </Group>
            </Box>
            <Box mt="xl" mb="xl" />
            <Text fs={'italic'} mt="xl" mb="xl" align="center">
                Let's make fashion sustainable, one outfit at a time.
            </Text>
            <Box mt="xl" />
        </Container>
    );
}